import axios from 'axios'
import store from '@/store'
import router from '@/router'
var Qs = require('qs');
import omitBy from 'lodash/omitBy'

let baseURL = process.env.VUE_APP_BASE_URL

export let http = axios.create({
  baseURL,
  withCredentials: true,
  paramsSerializer: function (params) {
    let query = Qs.stringify(omitBy(params, value => {
      return value === '' || value === null
    }), {
      arrayFormat: 'brackets'
    })
    return query || ''
  },
});

http.interceptors.request.use(config => {
  Object.assign(config.headers, {
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  })
  return config
})

http.interceptors.response.use(response => {
  if (response.status === 200 || response.status === 201) store.commit('global/clearErrors')
  return response
}, error => {
  if (error.response && error.response.status === 422) store.commit('global/setErrors', error.response.data)

  if (router.app && error.response && error.response.status === 401) {
    window.location.replace('https://app.runsnitch.io')
  }
  if (error.response && error.response.status === 403) {
    router.push({ name: 'dashboard' })
  }

  return Promise.reject(error)
});

export let get = (url, success, failure, options = {}) => http.get(url, {
  params: options.params
})
  .then(response => success(response))
  .catch(error => failure(error)
  )

export let post = (url, data, success, failure) => http.post(url, data)
  .then(response => success(response))
  .catch(error => failure(error)
  )

  export let burn = (url, data, success, failure) => http.delete(url, data)
  .then(response => success(response))
  .catch(error => failure(error)
  )

export default {
  get,
  post,
  burn
}
